import { Box, Button, Stack } from "@mui/material";
import React from "react";
import { Modal } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

const Footer = ({
    isLoadingSubmit,
    isLoadingTest,
    handleClose,
    onSubmitHandler,
    onTestButtonSubmitHandler,
    isEditMode = false,
}) => {
    const { handleSubmit } = useFormContext();

    const language = useSelector(
        (state: any) => state.languagesState.languages,
    );

    return (
        <Modal.Footer className="d-flex justify-between items-center">
            <Button
                color="error"
                variant="outlined"
                className="btn-black-outlined"
                onClick={handleClose}
                sx={{
                    minWidth: {
                        xs: "unset !important",
                    },
                }}
            >
                {language?.buttons?.close ?? "Close"}
            </Button>
            <Stack direction="row" gap={1}>
                <Button
                    className=""
                    color="primary"
                    variant="outlined"
                    onClick={onTestButtonSubmitHandler}
                    disabled={isLoadingTest}
                    sx={{
                        minWidth: {
                            xs: "unset !important",
                            md: "180px !important",
                        },
                    }}
                >
                    Test
                </Button>
                <Button
                    className=""
                    color="primary"
                    variant="contained"
                    onClick={handleSubmit(onSubmitHandler)}
                    disabled={isLoadingSubmit}
                    sx={{
                        minWidth: {
                            xs: "unset !important",
                            md: "180px !important",
                        },
                    }}
                >
                    {isEditMode ? "Update" : "Create"}
                </Button>
            </Stack>
        </Modal.Footer>
    );
};

export default Footer;
